import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connections } from '../../../../../api/integrations'
import Loading from '../../../../molecules/Loading'
import Divider from '../../../../atoms/Divider'
import { ADMIN_ROUTES } from '../../../../../constants'
import SydLinkButton from '../../../../commonDesign/LinkButton'
import CodeTag from '../../../../atoms/CodeTag'
import ConnectionRequestForm from './ConnectionRequestForm'

function ConnectionRequest ({ request }) {
  const { data: template, isLoading: templateLoading } = connections.useIntegrationConnectionTemplate(request.domain)
  const [completed, setCompleted] = useState(false)

  return (
    <div>
      {templateLoading ? (
        <Loading />
      ) : (!template?.connectionTemplate) ? (
        <div className='__error'>There was a problem loading the connection request</div>
      ) : (completed) ? (
        <div className='font-size-2xl'>
          <div>Thank you for completing the request</div>
          <SydLinkButton to={ADMIN_ROUTES.ADMIN}>Back to Admin</SydLinkButton>
        </div>
      ) : (
        <>
          <header>
            <p>
              Please review the following request to create an integration connection to <CodeTag style={{ display: 'inline-block' }}>{request.domain?.toUpperCase()}</CodeTag> using your provided credentials.
            </p>
          </header>
          <Divider additionalClasses='mb-5' />
          <ConnectionRequestForm
            request={request}
            template={template.connectionTemplate}
            onComplete={() => setCompleted(true)}
          />
        </>
      )}
    </div>
  )
}

ConnectionRequest.propTypes = {
  request: PropTypes.shape({
    connectionRequestId: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string,
    description: PropTypes.string,
    domain: PropTypes.string
  })
}

export default ConnectionRequest
